<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="2"
                lg="3"
                md="2"
                sm="2"
            >
                <h3>Sales Report</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="filter.mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-divider style="margin-bottom: 15px;"></v-divider>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="4"
                sm="12"
            >
                <label>Sales Person</label>
                <v-combobox
                    v-model="filter.sellerSelected"
                    :items="listSellers" 
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="6"
            >
                <label>Min Value</label>
                <v-text-field
                    v-model="filter.minValue" 
                    v-formatMoney="moneyFormat"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="6"
            >
                <label>Max Value</label>
                <v-text-field
                    v-model="filter.maxValue" 
                    v-formatMoney="moneyFormat"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="12"
            >
                <label>City</label>
                <v-combobox
                    v-model="filter.citySelected"
                    :items="listCity" 
                    item-text="codeStateDescriptionCity"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="8"
            >
                <label>Subdivision</label>
                <v-text-field
                    v-model="filter.subdivision"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="3"
                sm="12"
            >
                <label>Origin</label>
                <v-combobox
                    v-model="filter.customerOriginSelected"
                    :items="listCustomerOrigin"
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="2"
                sm="8"
            >
                <label>Zipcode</label>
                <v-text-field
                    v-model="filter.zipcode"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                style="text-align: right; margin-top: 22px;"
                cols="12"
                lg="1"
                md="1"
                sm="8"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">        
                <v-tabs
                    v-model="tabGraph"
                    fixed-tabs
                >
                    <v-tab key="1" @click="getRegisters">
                        By Month
                    </v-tab>
                    <v-tab key="2" @click="getRegisters">
                        By Status
                    </v-tab>
                    <v-tab key="3" @click="getRegisters">
                        By Sales Person
                    </v-tab>
                    <v-tab key="4" @click="getRegisters">
                        By Sales Person - Analytical
                    </v-tab>
                </v-tabs>
                
                <v-tabs-items v-model="tabGraph">

                    <!-- GRAPHIC BY MONTH -->
                    <v-tab-item key="1">
                        <br />

                        <v-tabs vertical fixed-tabs>
                            <v-tab @click="getRegisters">
                                Qty
                            </v-tab>
                            <v-tab @click="getRegisters">
                                Value
                            </v-tab>
                
                            <!-- BY QTY -->
                            <v-tab-item key="1">
                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartMonthQtd"
                                            :chartId="'dashboardSalesMonthByQtd'"
                                            :chartData="dashboardSalesMonthByQtd"
                                        />
                                    </v-col>
                                </v-row>
                                
                            </v-tab-item>

                            <!-- BY VALUE -->
                            <v-tab-item key="2">

                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartMonthValue"
                                            :chartId="'dashboardSalesMonthByValue'"
                                            :chartData="dashboardSalesMonthByValue"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>
                        </v-tabs>
                        
                    </v-tab-item>

                    <!-- GRAPHIC BY STATUS -->
                    <v-tab-item key="2">
                        <br />

                        <v-tabs vertical fixed-tabs>
                            <v-tab @click="getRegisters">
                                Qty
                            </v-tab>
                            <v-tab @click="getRegisters">
                                Value
                            </v-tab>

                            <!-- BY QTY -->
                            <v-tab-item key="1">

                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartStatusQtd"
                                            :chartId="'dashboardSalesStatusByQtd'"
                                            :chartData="dashboardSalesStatusByQtd"
                                        />
                                    </v-col>
                                </v-row>
                                
                            </v-tab-item>

                            <!-- BY VALUE -->
                            <v-tab-item key="2">

                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartStatusValue"
                                            :chartId="'dashboardSalesStatusByValue'"
                                            :chartData="dashboardSalesStatusByValue"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>
                        </v-tabs>

                    </v-tab-item>

                    <!-- GRAPHIC BY SALES PERSON -->
                    <v-tab-item key="3">
                        <br />

                        <v-tabs vertical fixed-tabs>
                            <v-tab @click="getRegisters">
                                Qty
                            </v-tab>
                            <v-tab @click="getRegisters">
                                Value
                            </v-tab>

                            <!-- BY QTY -->
                            <v-tab-item key="1">

                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartSalesPersonQtd"
                                            :chartId="'dashboardSalesSalesPersonByQtd'"
                                            :chartData="dashboardSalesSalesPersonByQtd"
                                        />
                                    </v-col>
                                </v-row>
                                
                            </v-tab-item>

                            <!-- BY VALUE -->
                            <v-tab-item key="2">

                                <v-row>
                                    <v-col 
                                        cols="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                    >
                                        <BarChart
                                            ref="chartSalesPersonValue"
                                            :chartId="'dashboardSalesSalesPersonByValue'"
                                            :chartData="dashboardSalesSalesPersonByValue"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>
                        </v-tabs>

                    </v-tab-item>

                    <!-- ANALYTICAL BY SALES PERSON -->
                    <v-tab-item key="4">
                        <br />

                        <v-col 
                            style="text-align: right;"
                            cols="12"
                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="exportFile(URL_REPORT_SALES_PERSON_ANALYTICAL, getFilterRequest());"
                                    >
                                        Export PDF
                                    </v-btn>
                                </template>
                                <span>Export Report to PDF</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="listSalesBySalesPersonAnalytical"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                :single-expand="true"
                                show-expand
                                no-data-text="No Record Found"
                                @click:row="showDetails"
                            >
                                <template v-slot:item.qtd="{ item }">
                                    <strong>{{ item.qtd }} </strong>                                    
                                </template>

                                <template v-slot:item.qtdJobsAccepted="{ item }">
                                    <strong>{{ item.qtdJobsAccepted }} </strong>
                                </template>
                                
                                <template v-slot:item.qtdJobsDenied="{ item }">
                                    <strong>{{ item.qtdJobsDenied }} </strong>
                                </template>
                                
                                <template v-slot:item.qtdJobsMissed="{ item }">
                                    <strong>{{ item.qtdJobsMissed }} </strong>
                                </template>
                                
                                <template v-slot:item.qtdScheduleBlocked="{ item }">
                                    <strong>{{ item.qtdScheduleBlocked }} </strong>
                                </template>
                                
                                <template v-slot:item.qtdScheduleBlockedInHours="{ item }">
                                    <strong>{{ item.qtdScheduleBlockedInHours }} </strong>
                                </template>

                                <template v-slot:item.qtdAttendedMeeting="{ item }">
                                    <strong>{{ item.qtdAttendedMeeting }} </strong>
                                </template>

                                <template v-slot:item.qtdNotAttendedMeeting="{ item }">
                                    <strong>{{ item.qtdNotAttendedMeeting }} </strong>
                                </template>

                                <template v-slot:item.valueFormatted="{ item }">
                                    <strong>{{ item.valueFormatted }} </strong>
                                </template>

                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length">
                                        <h3 style="margin-top: 10px;">Details</h3>
                                        <table cellspacing="10" style="width: 90%; border: none; margin: 15px;">
                                            <thead style="text-align: left;">
                                                <tr>
                                                    <th>Job Id</th>
                                                    <th>Contract Date</th>
                                                    <th>Homeowner</th>
                                                    <th>City</th>
                                                    <th>Address</th>
                                                    <th>Status</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody style="padding: 10px;">
                                                <tr v-for="(itemDetail, index) in item.listDetails" :key="index">
                                                    <td>
                                                        <v-tooltip left>
                                                            <template v-slot:activator="{ on }">
                                                                <a @click="goToServiceDetails(itemDetail.jobId)" v-on="on" target="_blank">
                                                                    {{ itemDetail.jobIdFormatted }}
                                                                </a>
                                                            </template>
                                                            <span>Job Details</span>
                                                        </v-tooltip>
                                                    </td>
                                                    <td>{{ itemDetail.contractDateFormatted }}</td>
                                                    <td>{{ itemDetail.customerName }}</td>
                                                    <td>{{ itemDetail.customerCity }}</td>
                                                    <td>{{ itemDetail.customerAddress }}</td>
                                                    <td>{{ itemDetail.statusDescription }}</td>
                                                    <td>{{ itemDetail.valueFormatted }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </template>

                                <template
                                    v-slot:footer
                                >
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <tbody style="padding: 10px;">
                                            <tr>
                                                <td style="width: 4%">&nbsp;</td>
                                                <td style="width: 15%; font-size: 25px; font-weight: bold;">Total</td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtd }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdJobsAccepted }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdJobsDenied }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdJobsMissed }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdScheduleBlocked }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdScheduleBlockedInHours }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdAttendedMeeting }}</v-chip>
                                                </td>
                                                <td style="width: 9%;" >
                                                    <v-chip dark>{{ totals.totalQtdNotAttendedMeeting }}</v-chip>
                                                </td>
                                                <td>
                                                    <v-chip dark>{{ totals.totalValue }}</v-chip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-tab-item>

                </v-tabs-items>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import BarChart from '@/components/Graphics/Bar.vue';
    import { formaterDecimalBR, formaterDecimalBRServer } from '@/utilities/Utils';
    import * as moment from 'moment';
    import { 
        URL_REPORT_SALES_PERSON_ANALYTICAL
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        components: {
            BarChart
        },

        data: () => ({
            
            loading: false,
            
            tabGraph: null,

            listSellers: [],
            listCity: [],
            listCustomerOrigin: [],

            filter: {
                sellerSelected: null,
                citySelected: null,
                subdivision: null,
                zipcode: null,
                customerOriginSelected: null,
                startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY'),
                minValue: "$ 0.00",
                maxValue: "$ 0.00"
            },

            dashboardSalesMonthByQtd: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},
            dashboardSalesMonthByValue: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            dashboardSalesStatusByQtd: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            dashboardSalesStatusByValue: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            dashboardSalesSalesPersonByQtd: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            dashboardSalesSalesPersonByValue: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            headers: [
                { text: "Sales person", value: "userName", width:"20%", sortable: true },
                { text: "Job Count", value: "qtd", width:"10%", sortable: true },
                { text: "Jobs Accepted", value: "qtdJobsAccepted", width:"10%", sortable: true },
                { text: "Jobs Denied", value: "qtdJobsDenied", width:"10%", sortable: true },
                { text: "Jobs Missed", value: "qtdJobsMissed", width:"10%", sortable: true },
                { text: "Schedule Blocked", value: "qtdScheduleBlocked", width:"10%", sortable: true },
                { text: "Schedule Blocked In Hours", value: "qtdScheduleBlockedInHours", width:"10%", sortable: true },
                { text: "Attended Meeting", value: "qtdAttendedMeeting", width:"10%", sortable: true },
                { text: "Not Attended Meeting", value: "qtdNotAttendedMeeting", width:"10%", sortable: true },
                { text: "Amount", value: "valueFormatted", width:"15%", sortable: true },
                { text: "Representation", value: "percRepresentationFormatted", width:"15%", sortable: true }
            ],

            options: { rowsPerPage: 10, page: 1 },
            listSalesBySalesPersonAnalytical: [],
            
            mnuStartDate: false,            
            mnuEndDate: false,

            listMonth: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],

            moneyFormat: {
                prefix: '$ ',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 2,
            },

            URL_REPORT_SALES_PERSON_ANALYTICAL
        }),

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        computed: {
            totals() {
                let totalQtd = 0;
                let totalQtdJobsAccepted = 0;
                let totalQtdJobsDenied = 0;
                let totalQtdJobsMissed = 0;
                let totalQtdScheduleBlocked = 0;
                let totalQtdScheduleBlockedInHours = 0;
                let totalQtdAttendedMeeting = 0;
                let totalQtdNotAttendedMeeting = 0;
                let totalValue = 0;

                if (this.listSalesBySalesPersonAnalytical != null && this.listSalesBySalesPersonAnalytical != undefined) {
                    this.listSalesBySalesPersonAnalytical.forEach(item => {
                        totalQtd += item.qtd;
                        totalQtdJobsAccepted += item.qtdJobsAccepted;
                        totalQtdJobsDenied += item.qtdJobsDenied;
                        totalQtdJobsMissed += item.qtdJobsMissed;
                        totalQtdScheduleBlocked += item.qtdScheduleBlocked;
                        totalQtdScheduleBlockedInHours += item.qtdScheduleBlockedInHours;
                        totalQtdAttendedMeeting += item.qtdAttendedMeeting;
                        totalQtdNotAttendedMeeting += item.qtdNotAttendedMeeting;

                        totalValue += parseFloat(item.value);
                    })
                }

                return {
                    totalQtd,
                    totalQtdJobsAccepted,
                    totalQtdJobsDenied,
                    totalQtdJobsMissed,
                    totalQtdScheduleBlocked,
                    totalQtdScheduleBlockedInHours,
                    totalQtdAttendedMeeting,
                    totalQtdNotAttendedMeeting,
                    totalValue: `$ ${formaterDecimalBR(totalValue.toFixed(2))}`
                }
            }
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            async getLists() {
                this.listSellers = await this.$store.dispatch("userModule/ListSalesPerson");
                this.listCity = await this.$store.dispatch("cityModule/List", 0);
                this.listCustomerOrigin = await this.$store.dispatch("customerOriginModule/List");
            },

            async getRegisters() {
                this.showLoading();
                await this.setGraphByMonth();
                await this.setGraphByStatus();
                await this.setGraphBySalesPerson();
                await this.getSalesBySalesPersonAnalytical();
                this.hideLoading();
            },
            
            generateColor(){
                return `#${Math.floor(Math.random()*16777215).toString(16)}`;
            },

            backgroundColors(data) {
                return data.map(() => this.generateColor())
            },

            getFilterRequest() {

                let idSalesPerson = 0;
                let idCity = 0;
                let idCustomerOrigin = 0;

                if (this.filter.sellerSelected != null && this.filter.sellerSelected != undefined) {
                    idSalesPerson = this.filter.sellerSelected.id;
                }

                if (this.filter.citySelected != null && this.filter.citySelected != undefined) {
                    idCity = this.filter.citySelected.id;
                }

                if (this.filter.customerOriginSelected != null && this.filter.customerOriginSelected != undefined) {
                    idCustomerOrigin = this.filter.customerOriginSelected.id;
                }

                const startDate = this.filter.startDate;
                const endDate = this.filter.endDate;
                const minValue = formaterDecimalBRServer(this.filter.minValue);
                const maxValue = formaterDecimalBRServer(this.filter.maxValue);
                const subdivision = this.filter.subdivision;
                const zipcode = this.filter.zipcode;
                
                const request = {
                    idSalesPerson,
                    idCity,
                    subdivision,
                    startDate,
                    endDate,
                    minValue,
                    maxValue,
                    idCustomerOrigin,
                    zipcode
                }

                return request;
            },
            
            async setGraphByMonth() {

                const listSalesByMonth = await this.$store.dispatch("reportModule/SalesByMonth", this.getFilterRequest());

                if (listSalesByMonth != null && listSalesByMonth.length > 0) {
                
                    this.dashboardSalesStatusByQtd.datasets = [];
                    this.dashboardSalesStatusByValue.datasets = [];

                    let qtdData = [];
                    let valueData = [];

                    listSalesByMonth.forEach(item => {
                        qtdData.push(item.qtd);
                        valueData.push(item.value);
                    });

                    this.dashboardSalesStatusByQtd.datasets.push({
                        label: "Qtd",
                        backgroundColor: "#018388",
                        borderColor: "#018388",
                        data: qtdData
                    });

                    this.dashboardSalesStatusByValue.datasets.push({
                        label: "Value",
                        backgroundColor: "#018388",
                        borderColor: "#018388",
                        data: valueData
                    });

                    if (this.$refs.chartMonthQtd) {
                        this.$refs.chartMonthQtd.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartMonthQtd.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByQtd.datasets;
                        this.$refs.chartMonthQtd.$refs.chart._data._chart.update("none");
                    }

                    if (this.$refs.chartMonthValue) {
                        this.$refs.chartMonthValue.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartMonthValue.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByValue.datasets;
                        this.$refs.chartMonthValue.$refs.chart._data._chart.update("none");
                    }

                }
            },

            async setGraphByStatus() {

                const listSalesByStatus = await this.$store.dispatch("reportModule/SalesByStatus", this.getFilterRequest());

                if (listSalesByStatus != null && listSalesByStatus.length > 0) {

                    const listUniqueId = [...new Set(listSalesByStatus.map((item) => item.status))];
                    
                    this.dashboardSalesStatusByQtd.datasets = [];
                    this.dashboardSalesStatusByValue.datasets = [];

                    listUniqueId.forEach(item => {

                        let qtdData = [];
                        let valueData = [];
                        let statusDescription = "";
                        listSalesByStatus.filter(dash => dash.status == item).forEach (dash => {
                            qtdData.push(dash.qtd);
                            valueData.push(dash.value);
                            statusDescription = dash.statusDescription;
                        });

                        this.dashboardSalesStatusByQtd.datasets.push({
                            label: statusDescription,
                            backgroundColor: this.generateColor(),
                            data: qtdData
                        });

                        this.dashboardSalesStatusByValue.datasets.push({
                            label: statusDescription,
                            backgroundColor: this.generateColor(),
                            data: valueData
                        });
                    });

                    if (this.$refs.chartStatusQtd) {
                        this.$refs.chartStatusQtd.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartStatusQtd.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByQtd.datasets;
                        this.$refs.chartStatusQtd.$refs.chart._data._chart.update("none");
                    }

                    if (this.$refs.chartStatusValue) {
                        this.$refs.chartStatusValue.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartStatusValue.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByValue.datasets;
                        this.$refs.chartStatusValue.$refs.chart._data._chart.update("none");
                    }

                }
            },

            async setGraphBySalesPerson() {

                const listSalesBySalesPerson = await this.$store.dispatch("reportModule/SalesBySalesPerson", this.getFilterRequest());

                if (listSalesBySalesPerson != null && listSalesBySalesPerson.length > 0) {

                    const listUniqueId = [...new Set(listSalesBySalesPerson.map((item) => item.idUser))];
                    
                    this.dashboardSalesSalesPersonByQtd.datasets = [];
                    this.dashboardSalesSalesPersonByValue.datasets = [];

                    listUniqueId.forEach(item => {

                        let qtdData = [];
                        let valueData = [];
                        let salesPersonName = "";
                        let graphColor = "";
                        listSalesBySalesPerson.filter(dash => dash.idUser == item).forEach (dash => {
                            qtdData.push(dash.qtd);
                            valueData.push(dash.value);
                            salesPersonName = dash.userName;
                            graphColor = dash.graphColor;
                        });

                        this.dashboardSalesSalesPersonByQtd.datasets.push({
                            label: salesPersonName,
                            backgroundColor: graphColor ?? this.generateColor(),
                            data: qtdData
                        });

                        this.dashboardSalesSalesPersonByValue.datasets.push({
                            label: salesPersonName,
                            backgroundColor: graphColor ?? this.generateColor(),
                            data: valueData
                        });
                    });

                    if (this.$refs.chartSalesPersonQtd) {
                        this.$refs.chartSalesPersonQtd.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartSalesPersonQtd.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesSalesPersonByQtd.datasets;
                        this.$refs.chartSalesPersonQtd.$refs.chart._data._chart.update("none");
                    }

                    if (this.$refs.chartSalesPersonValue) {
                        this.$refs.chartSalesPersonValue.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                        this.$refs.chartSalesPersonValue.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesSalesPersonByValue.datasets;
                        this.$refs.chartSalesPersonValue.$refs.chart._data._chart.update("none");
                    }
                }
            },

            async getSalesBySalesPersonAnalytical() {

                this.listSalesBySalesPersonAnalytical = await this.$store.dispatch("reportModule/SalesBySalesPersonAnalytical", this.getFilterRequest());
            },

            showDetails(_, item2) {
                item2.expand(true);
            },

            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: {id: id} });
            },
        },

        async created() {
            this.showLoading();
            await this.getLists();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>

<style>

    table > tbody > tr {
        cursor: pointer !important;
    }

</style>